<div *ngIf="annotation" class="p-2" style="font-size: 14px">


  <div class="mt-1" *ngIf="errMsg" >
    <div class="alert alert-danger">
      {{ 'MAP.' + errMsg | translate }}
    </div>
  </div>
  <div style="font-size: 14px;" *ngIf="!errMsg">
    {{'MAP.SPEED' | translate }}
    <input class="ml-2" type="number" min="1" value="1"  style="width: 70px;" [(ngModel)]="annotation.flyingSpeed"  name="speed" /> meters per second
    <div class="mt-2">
      <button class="ml-1" color="primary" mat-raised-button [disabled]="mapComp.flyingToLine" *ngIf="points?.length > 1" (click)="flyMe()"> {{ 'MAP.flyToLine' | translate }} <fa-icon style="font-size:18px;"  icon="paper-plane"></fa-icon> </button>

     <!-- <button class="ml-1" color="primary" mat-raised-button *ngIf="mapComp.flyingToLine" (click)="stopFlying()"> {{ 'MAP.STOP_FLYING' | translate }} <fa-icon style="font-size:18px;" icon="stop-circle"></fa-icon> </button>-->
    </div>

  </div>

  <hr/>
  <div>
    <b>{{ 'MAP.POINT_COUNT' | translate }}</b>
    <div>
      <div class="float-right">
        <button *ngIf="points?.length != 0" mat-icon-button  color="warn" (click)="nukePoints()"
                [matTooltip]="'MAP.CLEAR_POINTS' | translate">
          <fa-icon icon="eraser"></fa-icon>
        </button>
        <button *ngIf="pointsCopy?.length != 0 " mat-icon-button  color="primary" (click)="undoNukePoints()"
                [matTooltip]="'MAP.UNDO' | translate">
          <fa-icon icon="undo"></fa-icon>
        </button>
      </div>
      <span class="mt-2">
			{{ 'MAP.POINT_COUNT_STR' | translate: { points:points?.length } }}
		</span>
    </div>
  </div>
  <hr/>

  <div>
    <mat-form-field class="full-width mt-2 mb-2"  appearance="fill">
      <textarea matInput [(ngModel)]="annotation.desc" style="height:30px;" [placeholder]="'MAP.DESC' | translate"></textarea>
    </mat-form-field>
  </div>
  <div class="text-right">
    <button mat-raised-button color="warn" (click)="del()" class="mr-1">{{ 'GENERIC.DELETE' | translate }}</button>
    <button mat-raised-button color="primary" (click)="save(true)">{{ 'GENERIC.SAVE' | translate }}</button>
  </div>


  <div  class="mt-4 w-100 text-center" *ngIf="loading">
    <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
  </div>
